// extracted by mini-css-extract-plugin
export default {"modalText":"fKQ0Pfn4","imprintText":"i1xlLcXc","doneIcon":"_ywkvTzU","modalOptionText":"oakU0Rzj","modalWrapper":"Ir9wODi0","secondTitle":"tk2H5qkM","termCond":"tPNadPQA"};